import React, { createRef } from "react";
import { Link } from "react-router-dom";
import CookieConsent from "react-cookie-consent";

const Home = () => {
  const newRef = createRef();
  const scrollTo = () => {
    newRef.current.scrollIntoView({ beahvior: "smooth" });
  };
  return (
    <div>
      <div className='home-banner'>
        <div className='home-title'>
          <h1>E-učilnica za učence OŠ Bičevje</h1>
          <h3>biologija in naravoslovje</h3>
        </div>
      </div>
      <div className='icons-container'>
        <h2 className='home-top-title'>NAVODILA UPORABE STRANI</h2>
        <div className='icon-item'>
          <i className='fas fa-search'></i>
          <h1>1. KORAK</h1>
          <p>Preberi spodnja navodila.</p>
          <a href='#home-navodila-glavna'></a>
          <button onClick={() => scrollTo()}>Klikni me</button>
        </div>
        <div className='icon-item'>
          <i className='fas fa-user-graduate'></i>
          <h1>2. KORAK</h1>
          <p>Klikni na zavihek "Učne ure" ter izberi razred.</p>
        </div>
        <div className='icon-item'>
          <i className='fas fa-clipboard-check'></i>
          <h1>3. KORAK</h1>
          <p>Reši dane naloge.</p>
        </div>
      </div>
      <div className='home-navodila-container'>
        <div className='home-navodila-top'>
          <h1>
            Učiteljica sporoča, da je za vsa dodatna vprašanja dosegljiva na:
          </h1>
          <p>barbara.klun@guest.arnes.si</p>
        </div>
      </div>
      <div className='home-navodila-glavna' ref={newRef}>
        <h1>navodila učnih ur ter vaj</h1>
        <h2>Nekaj splošnih navodil, da ne bo prihajalo do nejasnosti.</h2>
        <h3>1. Splošna navodila</h3>

        <p>
          {" "}
          1. Vsako posredovano gradivo bo imelo zaporedno številko, naslov in
          datum. Zapiši tako v zvezek.
        </p>
        <p>
          {" "}
          2. Natančno preberi poslano gradivo. Izpiši si povzetek učne ure v
          zvezek.
        </p>
        <p>
          3. V kolikor dobiš nalogo, jo reši še isti dan in zapiši v zvezek.
        </p>
        <p>
          4. Pri delu uporabljaj spletno stran in vse dane digitalne vsebine,
          učbenik, delovni zvezek, zvezek.
        </p>
        <p>
          5. Opravljene vsebine naj bodo čitljive in urejene. Ob prihodu učencev
          v šolo bom opravljeno delo, ki ni digitalne narave, pregledala.
        </p>
        <p>
          6. Poleg učbenika in delovnega zvezka, bom pri vsaki uri navedla
          gradiva, kjer lahko najdete dodatne informacije.{" "}
        </p>
        <p>
          7. Vse možne brezplačne digitalne vsebine bodo navedene pod zavihkom
          "DOSTOP" v navigacijski vrstici zgoraj.
        </p>
        <p>Želim ti uspešno delo, učiteljica Barbara</p>

        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
      </div>
      <div className='quotes-container'>
        <div className='quotes'>
          <h1>“KDOR HOČE NAREDI, KDOR NOČE, NAJDE IZGOVOR...”</h1>
          <p>― Avtor neznan</p>
        </div>
      </div>
      <CookieConsent
        location='bottom'
        buttonText='Razumem'
        cookieName='myAwesomeCookieName2'
        style={{ background: "#2B373B" }}
        buttonStyle={{ color: "#4e503b", fontSize: "1.2rem" }}
        expires={150}
      >
        <span style={{ fontSize: "1.2rem" }}>
          Stran uporablja piškote za izboljšanje uporabe strani. Z nadaljno
          uporabo naše strani sprejemate uporabo piškotov.{" "}
        </span>
        <Link to='/cookies' style={{ color: "teal", fontSize: "1.2rem" }}>
          Več
        </Link>{" "}
      </CookieConsent>
    </div>
  );
};

export default Home;
